import { FC, ReactNode } from 'react'
import { TagProps as $TagProps } from 'antd/lib/tag/index'
import { Tag } from 'antd'
import PerIcon from '../Icon'
import { icons } from '../Icon/icons'
import PerSpacer from '../Spacer'
import './index.less'
import PerFlexRow from '../FlexRow'

type PerTagProps = $TagProps & {
  children: ReactNode
  color?: string
  icon?: keyof typeof icons
}

export const PerTag: FC<PerTagProps> = ({ color, icon, children, ...restProps }) => {
  return (
    <Tag color={color} {...restProps}>
      {icon && (
        <>
          <PerFlexRow align="middle">
            <PerIcon name={icon} size={8} />
            <PerSpacer mr="xxxs" />
            <>{children}</>
          </PerFlexRow>
        </>
      )}
      {!icon && <>{children}</>}
    </Tag>
  )
}
